import React from 'react';
import { FormattedMessage } from 'react-intl';
import { messages } from './messages';
import { Divider, Label, SplitItems, Value } from './styles';

type DetailedAccountInformationProps = {
  iban?: string;
  providerName?: string;
  holderName?: string;
};

export const DetailedAccountInformation: React.FC<DetailedAccountInformationProps> = ({
  providerName,
  iban,
  holderName,
}: DetailedAccountInformationProps) => {
  if (!providerName && !iban && !holderName) {
    return null;
  }

  return (
    <>
      <Divider />
      {providerName && (
        <SplitItems>
          <Label>
            <FormattedMessage {...messages.bank} />
          </Label>
          <Value bold>{providerName}</Value>
        </SplitItems>
      )}
      {holderName && (
        <SplitItems>
          <Label>
            <FormattedMessage {...messages.holderName} />
          </Label>
          <Value bold>{holderName}</Value>
        </SplitItems>
      )}
      {iban && (
        <SplitItems>
          <Label>
            <FormattedMessage {...messages.iban} />
          </Label>
          <Value bold>{iban}</Value>
        </SplitItems>
      )}
    </>
  );
};
